import Box from "@mui/material/Box";
import SearchPlaceholder from "designSystem/components/placeholder/SearchPlaceholder";
import OverflowText from "designSystem/components/text/OverflowText";
import { TooltipProps } from "designSystem/components/tooltip/Tooltip";
import { useDataSetupStore } from "csi/state/datasetup";
import { observer } from "mobx-react-lite";
import React from "react";
import DataSetupItemList from "./DataSetupItemList";

const DataSetupSearchContent = observer(() => {
	const dataSetupStore = useDataSetupStore();
	const { searchSections, searchSelectedItem } = dataSetupStore;
	const tooltipProps: Partial<TooltipProps> = { placement: "right" };

	if (searchSections.length) {
		return (
			<Box pb={4}>
				{searchSections.reduce((memo, section) => {
					memo.push(
						<Box
							key={section.id}
							px={4}
							py={2}
						>
							<OverflowText
								bold
								color="textSecondary"
								text={section.name}
								tooltipProps={tooltipProps}
							/>
						</Box>,
						<DataSetupItemList
							forSearch
							items={section.items}
							key={`${section.id}List`}
							selectedItem={searchSelectedItem}
							selectedSection={section}
						/>,
					);
					return memo;
				}, [])}
			</Box>
		);
	}

	return (
		<SearchPlaceholder subtitleProps={{ res: "DataSetupSearchHelpText" }} />
	);
});

export default DataSetupSearchContent;